import { ChevronUpIcon, TrashIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import { useMemo } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

const BillingFilters = ({ orgs, advisors, billingEmails, setBillingEmails, unfilteredEmails }) => {
	const [toggled, setToggled] = useState(false);
	const [filters, setFilters] = useState({});
	const [emailOptions, setEmailOptions] = useState([]);

	useEffect(() => {
		if (!unfilteredEmails) return;
		const newFilteredEmails = [...unfilteredEmails];
		const newEmailOptions = newFilteredEmails?.reduce((unique, o) => {
			if (!unique.some((obj) => obj.value === o.email)) {
				unique.push({ value: o.email, label: o.email });
			}
			return unique;
		}, []);
		setEmailOptions(newEmailOptions);
	}, [unfilteredEmails]);

	const updateField = (field, value) => {
		const newFilters = { ...filters };

		newFilters[field] = value;

		setFilters(newFilters);
	};

	useMemo(() => {
		if (!unfilteredEmails) return;
		const newBillingEmails = [...unfilteredEmails];

		//billingID is either the advisorID or orgID
		const filteredBillingEmails = newBillingEmails.filter((email) => {
			const emailMatch = filters.email ? email.email === filters.email : true;
			const advisorMatch = filters.advisor ? email.billingId === filters.advisor : true;
			const orgMatch = filters.org ? email.billingId === filters.org : true;

			return emailMatch && advisorMatch && orgMatch;
		});

		setBillingEmails(filteredBillingEmails);
	}, [filters]);

	return (
		<>
			<div
				className="col-sm-12"
				style={{ marginBottom: 10 }}
			>
				<div className="pull-left">
					<button
						className="btn btn-primary"
						onClick={() => setToggled(!toggled)}
					>
						<span style={{ float: "left" }}>Filters</span>
						<ChevronUpIcon
							style={{
								height: "1.5em",
								float: "left",
								marginLeft: 5,
								transform: toggled ? "rotateX(0deg)" : "rotateX(180deg)",
								transition: "transform 0.3s",
							}}
						/>
					</button>
				</div>
			</div>
			{toggled && (
				<>
					<div
						className="col-xs-12"
						style={{ marginBottom: 10 }}
					>
						<div
							className="col-xs-2"
							style={{ padding: 0 }}
						>
							<label>Org</label>
							<Select
								value={orgs.find((org) => org.value === filters.org) || null}
								options={orgs}
								onChange={(e) => {
									updateField("org", e.value);
								}}
							/>
						</div>
						<div
							className="col-xs-2"
							style={{ padding: 0, marginLeft: 15 }}
						>
							<label>Advisor</label>
							<Select
								value={advisors.find((advisor) => advisor.value === filters.advisor) || null}
								options={advisors}
								onChange={(e) => {
									updateField("advisor", e.value);
								}}
							/>
						</div>
						<div
							className="col-xs-2"
							style={{ padding: 0, marginLeft: 15 }}
						>
							<label>Email</label>
							<Select
								value={emailOptions.find((email) => email.value === filters.email) || null}
								options={emailOptions}
								onChange={(e) => {
									updateField("email", e.value);
								}}
							/>
						</div>
						<div
							className="col-xs-2"
							style={{ padding: 0, marginLeft: 15 }}
						>
							<button
								className="btn btn-danger"
								style={{ marginTop: "1.7em" }}
								onClick={() => setFilters({})}
							>
								<TrashIcon style={{ height: "1.5em", float: "left" }} />
							</button>
						</div>
					</div>
				</>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const advisors = state?.advisors?.advisorList || [];
	const organisations = state?.admin?.organisations || [];

	const mappedAdvisors = advisors.map(({ id, name }) => {
		return { value: id, label: name };
	});

	return {
		advisors: mappedAdvisors,
		orgs: organisations.map(({ id, name }) => ({ value: id, label: name })),
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BillingFilters);
